// extracted by mini-css-extract-plugin
module.exports = {"forum":"forum--26sB1","forum_cont":"forum_cont--1U01S","loading":"loading--3wcup","forum_detail":"forum_detail--G9laf","forum_detail_content":"forum_detail_content--2HvoH"};